import React from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Marie Dubois',
      role: 'Particulier - Paris 15e',
      rating: 5,
      comment: 'Intervention rapide et efficace pour une fuite d\'urgence. Le technicien était professionnel et a tout expliqué clairement. Je recommande vivement !',
      service: 'Réparation d\'urgence',
      date: 'Il y a 2 semaines'
    },
    {
      name: 'Jean Martin',
      role: 'Copropriété - Boulogne',
      rating: 5,
      comment: 'Excellent service pour l\'installation de notre nouveau système de chauffage. Travail soigné, respect des délais et prix transparent.',
      service: 'Installation',
      date: 'Il y a 1 mois'
    },
    {
      name: 'Sophie Laurent',
      role: 'Commerce - Neuilly',
      rating: 5,
      comment: 'Le contrat de maintenance nous a évité plusieurs pannes coûteuses. L\'équipe est réactive et les rappels automatiques sont très pratiques.',
      service: 'Maintenance',
      date: 'Il y a 3 semaines'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Ce que disent nos clients
          </h2>
          <p className="text-lg text-muted-foreground">
            Plus de 2,500 clients satisfaits nous font confiance
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials?.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-card border border-border rounded-xl p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) => (
                  <Icon key={i} name="Star" size={18} className="text-warning fill-warning" />
                ))}
              </div>
              
              <p className="text-foreground mb-4 leading-relaxed">
                "{testimonial?.comment}"
              </p>
              
              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div>
                  <div className="font-semibold text-foreground">{testimonial?.name}</div>
                  <div className="text-sm text-muted-foreground">{testimonial?.role}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs font-medium text-primary">{testimonial?.service}</div>
                  <div className="text-xs text-muted-foreground">{testimonial?.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;